import React from 'react'
import { useAppConfigContext } from 'src/viewLayer/components/contexts/AppConfigContext'
// Hooks
import usePerformanceTracker from 'src/viewLayer/components/hooks/usePerformanceTracker'
import Footer from 'src/viewLayer/components/pages/CardLayout/Footer'
import LoginBusinessPage from 'src/viewLayer/components/pages/LoginBusinessPage'

import { FooterContainer, LoginBusinessPageContainer } from './index.styled'
// Components
import NavBar from './NavBar'

const WebBusinessPage = ({ appType }) => (
  <LoginBusinessPageContainer>
    <NavBar />
    <LoginBusinessPage appType={appType}>
      <FooterContainer>
        <Footer color="transparent" />
      </FooterContainer>
    </LoginBusinessPage>
  </LoginBusinessPageContainer>
)

const NativeMobileBusinessPage = ({ appType }) => <LoginBusinessPage appType={appType} />

export default function BusinessPages(properties) {
  usePerformanceTracker()
  const { devicePath } = useAppConfigContext()

  return devicePath === 'login' ? (
    <WebBusinessPage {...properties} />
  ) : (
    <NativeMobileBusinessPage {...properties} />
  )
}
